export function IconFromType (type, defaultIcon) {
  switch (type) {
    case 'study':
      return 'description'
    case 'directory':
      return 'folder'
    case 'container_dicom':
      return 'group_work'
    case 'dicom_vault':
      return 'group_work'
    case 'document_vault':
      return 'cloud_download'
    case 'case':
      return 'chrome_reader_mode'
    case 'application':
      return 'apps'
    case 'audio':
      return 'audiotrack'
    case 'font':
      return 'font_download'
    case 'image':
      return 'photo'
    case 'message':
      return 'message'
    case 'video':
      return 'play_circle_outline'
    case 'document':
      return 'insert_drive_file'
    default:
      if (type && defaultIcon === undefined) {
        console.warn('No icon setted for type ' + type)
      }
      return defaultIcon
  }
}



// WEBPACK FOOTER //
// ./src/helpers/icon.js